export default "__VITE_ASSET__DfClDciX__"